/* Product-card tier price table (Approach A) — switches State 1 / State 2 by live cart
   subtotal and re-checks after every cart change. DISPLAY ONLY; the real discount is a
   native Shopify automatic discount. Loaded once per page (guarded). */
(function () {
  if (window.__tierCardInit) return;
  window.__tierCardInit = true;

  var lastSubtotal = null;
  var pending = null;

  function applyOne(root) {
    if (lastSubtotal === null) return;
    var rows = Array.prototype.slice.call(root.querySelectorAll('.tier-row[data-threshold-cents]'));
    var activeIdx = -1;
    rows.forEach(function (row, i) {
      row.classList.remove('tier-row--active', 'tier-row--passed');
      if (lastSubtotal >= parseInt(row.getAttribute('data-threshold-cents'), 10)) activeIdx = i;
    });
    var active = activeIdx >= 0 ? rows[activeIdx] : null;
    if (active) {
      // rows are in ascending threshold order: lower thresholds than active = already passed
      rows.forEach(function (row, i) {
        if (i < activeIdx) row.classList.add('tier-row--passed');
        else if (i === activeIdx) row.classList.add('tier-row--active');
      });
    }
    var hero = root.querySelector('.tier-hero-price');
    var label = root.querySelector('.tier-hero-label');
    var ref = root.querySelector('.tier-wholesale-ref');
    var badge = root.querySelector('.tier-badge');
    if (active) {
      // State 2 — tier reached
      if (hero) hero.textContent = active.getAttribute('data-price');
      if (label) label.hidden = true;
      if (ref) ref.hidden = false;
      if (badge) {
        badge.textContent = (root.getAttribute('data-badge-prefix') || '') + ' · ' + active.getAttribute('data-order');
        badge.hidden = false;
      }
    } else {
      // State 1 — no tier reached
      if (hero) hero.textContent = hero.getAttribute('data-wholesale');
      if (label) label.hidden = false;
      if (ref) ref.hidden = true;
      if (badge) { badge.hidden = true; badge.textContent = ''; }
    }
  }

  function applyAll() {
    document.querySelectorAll('[data-tier-card]').forEach(applyOne);
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var s = 0;
        // original_line_price = pre-discount subtotal, the basis Shopify's tier minimum uses.
        (cart.items || []).forEach(function (it) { s += (it.original_line_price || 0); });
        lastSubtotal = s;
        applyAll();
      })
      .catch(function () {});
  }

  function scheduleRefresh() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; refresh(); }, 90);
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  // Intercept fetch() cart mutations (custom add-to-cart may not fire the theme's pub/sub).
  if (window.fetch && !window.fetch.__tierWrapped) {
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = (input && input.url) ? input.url : (typeof input === 'string' ? input : '');
      var res = origFetch.apply(this, arguments);
      if (CART_MUTATION.test(url)) { res.then(scheduleRefresh).catch(function () {}); }
      return res;
    };
    window.fetch.__tierWrapped = true;
  }

  // Intercept XMLHttpRequest cart mutations (XHR/jQuery-based carts).
  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__tierWrapped) {
    var oOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, url) { this.__tierCart = CART_MUTATION.test(url || ''); return oOpen.apply(this, arguments); };
    var oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () { if (this.__tierCart) this.addEventListener('load', scheduleRefresh); return oSend.apply(this, arguments); };
    XMLHttpRequest.prototype.__tierWrapped = true;
  }

  if (document.readyState !== 'loading') refresh();
  else document.addEventListener('DOMContentLoaded', refresh);

  // Belt-and-suspenders: Dawn cart pub/sub, back-nav, section reloads.
  try { if (window.subscribe && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refresh); } catch (e) {}
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);

  // Apply cached state to tier cards injected by AJAX pagination/filtering.
  // Only reacts to genuinely-new cards (not our own text/class edits) to avoid a loop.
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && ((n.matches && n.matches('[data-tier-card]')) || (n.querySelector && n.querySelector('[data-tier-card]')))) {
            applyAll();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
